import { ContentContainer } from "modules/addons/components//DigitalOnboarding";
import commonStyles from "modules/addons/components/css/PPSRRegistration/EditComponent.css";
import React from "react";

export default function NZDebtorDetails(): React.ReactElement {
  return (
    <ContentContainer header="Step 4: Grantor details.">
      <div className={commonStyles.sub_header}>
        These details will be automatically pre-populated onto your
        registration from the application details.
      </div>
      <div>Type: individual/organisation</div>
      <div>Name (Organisation name/first, last name)</div>
      <div>ARSN/ACN/ARBN/ABN</div>
      <div>DOB (only for individual type)</div>
    </ContentContainer>
  )
}
